import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { ErrorShowService } from './error-show.service';
import { LoginService } from './login.service';
import { TokenService } from './token.service';
import { LoadingService } from '../appLoader/loading.service';
import { RoleAccessService } from './roleAccess.service';

@Injectable({
  providedIn: 'root',
})
export class RememberMeService {
  constructor(
    private tokenService: TokenService,
    private route: Router,
    private loginService: LoginService, private roleService: RoleAccessService,
    private errorShowService: ErrorShowService, private loadingService: LoadingService
  ) { }
  public isLoading: boolean = false;

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | boolean {

    var loginDetails = this.tokenService.getRememberMeDetails();
    //console.log(loginDetails)
    //console.log(this.tokenService.getFranchiseList())
    //console.log(this.tokenService.getUserData())
    if (this.tokenService.getFranchiseList() && this.tokenService.getUserData()) {
      console.log("in franchise list - lets load offline")
      this.loadingService.show();
      localStorage.removeItem("adminCorner");
      let self = this;
      self.route.navigate([this.roleService.getDefaultRedirection()]).then(function () { self.loadingService.hide(); });
      return true;

    }
    else if (this.tokenService.getRememberMe() && this.tokenService.getRememberMeDetails() && this.tokenService.getFranchiseList() == null) {
      console.log("in")
      this.loadingService.show();
      this.loginService
        .loginService(this.tokenService.getRememberMeDetails())
        .subscribe({
          next: (res) => {
            if (res['STATUS'] === '1') {
              this.tokenService.setRememberMe(loginDetails, res['DATA'][0].AUTH_CODE);
              this.tokenService.setLoginData(this.tokenService.getRememberMeDetails(), res['DATA'][0]);
              //this.tokenService.setToken(res['DATA'][0].AUTH_CODE);
              //this.tokenService.setUser(res['DATA'][0]);
              //this.tokenService.setSubprojectID(res['DATA'][0]['SUBPROJECTID']);

              //remember me
              //this.tokenService.setRememberMe(this.tokenService.getRememberMeDetails(), res['DATA'][0].AUTH_CODE);
              localStorage.removeItem("adminCorner");
              let self = this;
              //self.route.navigate([this.tokenService.getThemeBaseDashboardRoute()]).then(function () { self.loadingService.hide(); });
              self.route.navigate([this.roleService.getDefaultRedirection()]).then(function () { self.loadingService.hide(); });
            } else {
              this.errorShowService.showError(res['MESSAGE']);
              this.route.navigate(['/login']);
              this.loadingService.hide();
            }
          },
          error: (err) => {
            this.errorShowService.showError(err['MESSAGE']);
            this.loadingService.hide();
          },
        });

      return true;
      // return false;
    }
    else {
      return true;
    }
  }
}
